var map = {
	"./Anyswap.png": 481,
	"./Anyswap.svg": 482,
	"./Artwork.svg": 483,
	"./Artwork_gmx.svg": 484,
	"./Banxa.png": 485,
	"./DROP_DOWN.svg": 284,
	"./Frame.svg": 486,
	"./Hop.png": 487,
	"./Hop.svg": 488,
	"./Hop_dark.png": 489,
	"./Hop_dark.svg": 490,
	"./Synapse.png": 491,
	"./Synapse.svg": 492,
	"./amx.png": 493,
	"./binance.png": 494,
	"./bscscan.png": 495,
	"./btn_big_arbitrum.png": 496,
	"./btn_big_avalanche.png": 497,
	"./btn_big_bsc.png": 498,
	"./btn_big_purchasegmx.png": 499,
	"./btn_big_purchasegmx.svg": 500,
	"./buy_gmx.svg": 285,
	"./buy_gmx_bond.svg": 501,
	"./buy_transfer_eth.svg": 502,
	"./coinbaseWallet.png": 286,
	"./coingecko.png": 503,
	"./cross.svg": 504,
	"./dlp.png": 505,
	"./flag_en.svg": 506,
	"./flag_es.svg": 507,
	"./flag_fr.svg": 508,
	"./flag_ja.svg": 509,
	"./flag_ko.svg": 510,
	"./flag_ru.svg": 511,
	"./flag_zh.svg": 512,
	"./glp_icon.svg": 513,
	"./gmx-logo-final-white-small.png": 514,
	"./gmx-logo-final-white.png": 515,
	"./gmx-logo-final.png": 516,
	"./gmx-logo-glow.png": 517,
	"./gmx-logo-with-name.svg": 287,
	"./gmx_logo.svg": 518,
	"./graphite-01.png": 519,
	"./ic-communityproject.svg": 520,
	"./ic_aave_24.svg": 521,
	"./ic_aave_30.svg": 522,
	"./ic_aave_40.svg": 523,
	"./ic_arbitrum_16.svg": 129,
	"./ic_arbitrum_24.svg": 171,
	"./ic_arbitrum_96.svg": 172,
	"./ic_arbitrum_hover_16.svg": 524,
	"./ic_arrowleft16.svg": 525,
	"./ic_arrowright16.svg": 526,
	"./ic_avalanche_16.svg": 527,
	"./ic_avalanche_24.svg": 528,
	"./ic_avalanche_96.svg": 529,
	"./ic_avax_24.svg": 530,
	"./ic_avax_30.svg": 531,
	"./ic_avax_40.svg": 532,
	"./ic_banxa.svg": 288,
	"./ic_binance.svg": 533,
	"./ic_binance_logo.svg": 534,
	"./ic_bsc.svg": 535,
	"./ic_bsc_96.svg": 536,
	"./ic_btc.b_24.svg": 537,
	"./ic_btc.b_40.svg": 538,
	"./ic_btc_24.svg": 539,
	"./ic_btc_40.svg": 540,
	"./ic_bungee.png": 289,
	"./ic_busd_24.svg": 541,
	"./ic_buy_glp.svg": 290,
	"./ic_cash.png": 542,
	"./ic_cash.svg": 543,
	"./ic_checked.svg": 200,
	"./ic_coingecko_16.svg": 291,
	"./ic_coingecko_hover_16.svg": 544,
	"./ic_convert_down.svg": 292,
	"./ic_copy_16.svg": 293,
	"./ic_cost.svg": 294,
	"./ic_dai_24.svg": 545,
	"./ic_dai_40.svg": 546,
	"./ic_discord.svg": 295,
	"./ic_eth_24.svg": 547,
	"./ic_eth_40.svg": 548,
	"./ic_frax_24.svg": 549,
	"./ic_frax_40.svg": 550,
	"./ic_github.svg": 296,
	"./ic_glp_24.svg": 241,
	"./ic_glp_40.svg": 201,
	"./ic_glp_40_.svg": 551,
	"./ic_glp_custom.svg": 297,
	"./ic_glp_custom_.svg": 552,
	"./ic_gmx.svg": 553,
	"./ic_gmx_24.svg": 554,
	"./ic_gmx_30.svg": 555,
	"./ic_gmx_40.svg": 298,
	"./ic_gmx_40_.svg": 556,
	"./ic_gmx_64.svg": 557,
	"./ic_gmx_arbitrum.svg": 558,
	"./ic_gmx_avax.svg": 559,
	"./ic_gmx_big.svg": 560,
	"./ic_gmx_custom.svg": 299,
	"./ic_gmx_custom_.svg": 561,
	"./ic_gmx_footer.svg": 300,
	"./ic_gmx_footer_.svg": 562,
	"./ic_gmx_footer_org.svg": 563,
	"./ic_hop.svg": 564,
	"./ic_info.svg": 565,
	"./ic_language24.svg": 173,
	"./ic_link.e_40.svg": 566,
	"./ic_link_24.svg": 567,
	"./ic_link_40.svg": 568,
	"./ic_liquidity.svg": 301,
	"./ic_matic_24.svg": 174,
	"./ic_matic_40.svg": 569,
	"./ic_medium.svg": 302,
	"./ic_menu_dots.svg": 570,
	"./ic_metamask_16.svg": 303,
	"./ic_metamask_hover_16.svg": 571,
	"./ic_mim_24.svg": 572,
	"./ic_mim_40.svg": 573,
	"./ic_multiswap.svg": 574,
	"./ic_new_link_16.svg": 304,
	"./ic_o3.png": 305,
	"./ic_olympus.svg": 575,
	"./ic_olympus_arbitrum.svg": 306,
	"./ic_polygon_16.svg": 116,
	"./ic_polygon_24.svg": 576,
	"./ic_polygon_96.svg": 175,
	"./ic_selector_dropdowns.svg": 577,
	"./ic_settings_16.svg": 242,
	"./ic_settings_24.svg": 578,
	"./ic_sign in_16.svg": 579,
	"./ic_sign_out_16.svg": 307,
	"./ic_simpleswaps.svg": 308,
	"./ic_stats.svg": 309,
	"./ic_stats_big.svg": 580,
	"./ic_synapse.svg": 581,
	"./ic_telegram.svg": 310,
	"./ic_tether_24.svg": 582,
	"./ic_tokens.svg": 583,
	"./ic_totaluser.svg": 311,
	"./ic_traderjoe.png": 584,
	"./ic_traderjoe.svg": 312,
	"./ic_trading.svg": 313,
	"./ic_transfer_avax.svg": 585,
	"./ic_twitter.svg": 314,
	"./ic_uni_24.svg": 586,
	"./ic_uni_40.svg": 587,
	"./ic_uni_arbitrum.svg": 315,
	"./ic_usdc.e_24.svg": 588,
	"./ic_usdc.e_40.svg": 589,
	"./ic_usdc_24.svg": 590,
	"./ic_usdc_40.svg": 591,
	"./ic_usdt_24.svg": 592,
	"./ic_usdt_40.svg": 593,
	"./ic_wallet_24.svg": 316,
	"./ic_wavax_24.svg": 594,
	"./ic_wavax_40.svg": 595,
	"./ic_wbtc_24.svg": 596,
	"./ic_wbtc_40.svg": 597,
	"./ic_weth_24.svg": 598,
	"./ic_weth_40.svg": 599,
	"./ic_wmatic_24.svg": 600,
	"./ic_wmatic_40.svg": 601,
	"./lg_arbitrum.svg": 602,
	"./logo_GMX.svg": 176,
	"./logo_GMX_.svg": 603,
	"./logo_GMX_org.svg": 604,
	"./logo_GMX_small.svg": 243,
	"./logo_GMX_small_.svg": 605,
	"./long.svg": 317,
	"./metamask-text.svg": 606,
	"./metamask.png": 318,
	"./page-not-found.svg": 607,
	"./position-share-bg.png": 319,
	"./short.svg": 320,
	"./swap.svg": 321,
	"./trading.jpg": 608,
	"./wallet-connect-text.svg": 609,
	"./walletconnect-circle-blue.svg": 322,
	"./wave-01.png": 610,
	"./wave-02.png": 611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;